<template>
    <div class="project-container">
        <div class="row">
            <div class="left">
                <span>创建时间：</span>
                <el-date-picker v-model="startDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择日期">
                </el-date-picker>
                <el-date-picker v-model="endDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date"
                    placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="right">
                <el-input placeholder="请输入内容" v-model="searchStr" class="input-with-select">
                    <el-select v-model="searchType" slot="prepend" placeholder="请选择">
                        <el-option label="项目名称" value="projectName"></el-option>
                        <el-option label="项目编号" value="projectNumber"></el-option>
                    </el-select>
                </el-input>
                <el-button icon="el-icon-search" type="primary" @click="getData">搜 索</el-button>
                <el-button type="primary" @click="initData">重 置</el-button>
            </div>
        </div>
        <el-table :data="tableData" border style="width: 100%" max-height="780px" :header-cell-style="getTableHeader()"
            stripe v-loading="loadData">
            <el-table-column prop="projectName" label="项目名称" align="center">
            </el-table-column>
            <el-table-column prop="projectNumber" label="项目编号" align="center">
            </el-table-column>
            <el-table-column prop="projectEstablishmentTime" label="立项时间" align="center">
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" @click="showRow(scope.row)">
                        查看
                    </el-button>
                    <el-button type="primary" @click="distributeData(scope.row)">
                        分配
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="page-block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                :page-sizes="[10, 20, 50, 100, 200, 300, 500]" :page-size="size"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
        <el-dialog title="资源详情" :visible.sync="dialogVisible" width="80%" :before-close="handleClose">
            <el-tabs tab-position="left" class="dialog-box">
                <el-tab-pane label="基本信息">
                    <el-table :data="resourceData" border style="width: 100%" :header-cell-style="getTableHeader()"
                        stripe>
                        <el-table-column type="index" label="序号" align="center"></el-table-column>
                        <el-table-column :prop="item.prop" :label="item.label" :width="item.width"
                            v-for="item in resourceHeader" :key="item.prop" align="center">
                        </el-table-column>
                        <el-table-column prop="address" label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button type="primary" @click="distributeRow(scope.row)"
                                    :disabled="scope.row.allocatedQuantity == scope.row.resourceQuantity">分配</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
                <el-tab-pane label="分配情况">
                    <div class="box shop">
                        <Editable :headerStyle="getTableHeader()" height="420" :value="distributionData"
                            :header="distributionHeader" @delRow="delRow">
                        </Editable>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog title="分配" :visible.sync="showDistributeDialog" width="80%">
            <div class="box">
                <div class="item w50">
                    <div class="label">资源名称</div>
                    <el-select v-model="resourceInfo.id" :disabled="dialogVisible" placeholder="请选择" clearable>
                        <el-option :label="item.resourceName" :value="item.id" :key="item.id"
                            v-for="item in resourceData"
                            :disabled="item.allocatedQuantity == item.resourceQuantity"></el-option>
                    </el-select>
                </div>

                <div class="item w50">
                    <div class="label">单位</div>
                    <div class="value">
                        {{ resourceHeader.filter(item => item.label != '资源名称').map(item => {
                        return item.label + '：' + resourceValue(item)
                        }).join(' ') }}
                    </div>
                </div>

                <div class="item w50">
                    <div class="label">用户</div>
                    <el-select v-model="resourceInfo.userId" placeholder="请选择" clearable>
                        <el-option :label="item.userName + '-' + item.telephone" :value="item.uid" :key="item.uid"
                            v-for="item in personList"></el-option>
                    </el-select>
                </div>
                <div class="item w50">
                    <div class="label">分配数量</div>
                    <ElInputTrim v-model="resourceInfo.resourceNumber" valueType="int" type="text"></ElInputTrim>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showDistributeDialog = false">取 消</el-button>
                <el-button type="primary" @click="submit">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getTableHeader } from '../../assets/js/common.js'
import Editable from '@/components/Editable';
import { ajaxGet, ajaxPost, Baseurl } from '../../api/api/api.js';
import { mapState } from 'vuex';
import ElInputTrim from '@/components/ElInputTrim/index.vue';
export default {
    name: 'ResourceConfiguration',
    components: {
        Editable,
        ElInputTrim
    },
    props: {},
    data() {
        return {
            startDate: '',
            endDate: '',
            searchStr: '',
            searchType: 'projectName',
            page: 1,
            size: 10,
            total: 0,
            dialogVisible: false,
            tableData: [],
            projectId: null,
            personList: [],
            resourceData: [],
            resourceHeader: [
                { prop: 'resourceName', label: '资源名称', type: 'input' },
                { prop: 'resourceUnit', label: '资源单位', type: 'input' },
                { prop: 'resourceQuantity', label: '资源数量', type: 'input' },
                { prop: 'resourceUnitPrice', label: '资源单价', type: 'input' },
                { prop: 'allocatedQuantity', label: '已分配数量', type: 'input' },
            ],
            distributionHeader: [
                { prop: 'resourceName', label: '资源名称', type: 'input' },
                { prop: 'resourceUnit', label: '资源单位', type: 'input' },
                { prop: 'resourceQuantity', label: '资源数量', type: 'input' },
                { prop: 'resourceUnitPrice', label: '资源单价', type: 'input' },
                { prop: 'allocationQuantity', label: '分配数量', type: 'input' },
                { prop: 'user', label: '用户', type: 'input' },
            ],
            distributionData: [],
            loadData: false,
            showDistributeDialog: false,
            resourceMap: {},
            resourceInfo: {
                id: '',
                userId: '',
                resourceNumber: '',
            },
            isSubmit: false,
        };
    },
    watch: {},
    computed: {
        ...mapState({
            role: state => state.user.role,
        })
    },
    created() {
        // this.endDate = this.formatDate(new Date().getTime());
        // this.startDate = this.endDate.substring(0, 7) + '-01';
    },
    mounted() {
        this.getData();
    },
    methods: {
        delRow(row) {
            this.distributionData.splice(row.$index, 1);
        },
        formatDate(timestamp) {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        resourceValue(item){
            if (this.resourceMap[this.resourceInfo.id] && (this.resourceMap[this.resourceInfo.id][item.prop] || this.resourceMap[this.resourceInfo.id][item.prop] === 0)){
                return this.resourceMap[this.resourceInfo.id][item.prop]
            }
            return '';
        },
        distributeRow(row){
            this.resourceInfo.id = row.id;
            this.resourceInfo.userId  = '';
            this.resourceInfo.resourceNumber = '';
            this.showDistributeDialog = true;
        },
        async getProjectDetail(id){
            const params = {
                id: id,
            }
            this.resourceMap = {};
            this.resourceInfo = {
                id: '',
                userId: '',
                resourceNumber: '',
            };
            const resp = await ajaxPost(Baseurl + 'projectController/selectProjectDetail', params)
            if (resp.status === 200) {
                const res = resp.data;
                if (res.code === 200) {
                    const row = res.data;
                    const obj = {};
                    for(let i = 0; i < row.projectResourcess.length; i++){
                        const item = row.projectResourcess[i];
                        obj[item.id] = item;
                    }
                    this.resourceMap = obj;
                    return row;
                } else {
                    this.$message.error(res.message)
                }
            }
            return null;
        },
        // 显示某一行
        async showRow(d) {
            await this.getProjectDetail(d.id).then(row => {
                if (row) {
                    this.personList = row.projectUsers;
                    this.resourceData = row.projectResourcess;
                    this.projectId = d.id;
                }
            });
            console.log(JSON.parse(JSON.stringify(this.resourceMap)));
            ajaxPost(Baseurl + 'projectResourceController/selectProjectResourceUsers', { projectId: d.id }).then(resp => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        console.log(JSON.parse(JSON.stringify(res.data)));
                        this.distributionData = res.data.map(item => {
                            return {
                                ...item,
                                user: item.userName + '-' + item.telephone,
                                ...this.resourceMap[item.resourceId]
                            }
                        });
                    } else {
                        this.$message.error(res.message);
                    }
                    if (!this.resourceData.length) {
                        this.$message.error('该项目没有资源信息，请先添加资源！');
                        return;
                    }
                    this.dialogVisible = true;
                }
            });
        },
        // 分配资源
        distributeData(d){
            this.getProjectDetail(d.id).then(row => {
                if (row) {
                    this.personList = row.projectUsers;
                    this.resourceData = row.projectResourcess;
                    this.projectId = d.id;
                    if (!this.resourceData.length) {
                        this.$message.error('该项目没有资源信息，请先添加资源！');
                        return;
                    }
                    this.showDistributeDialog = true;
                }
            });
        },
        initData() {
            this.startDate = '';
            this.endDate = '';
            this.searchStr = '';
            this.page = 1;
            this.size = 10;
            this.searchType = 'projectName';
            this.getData();
        },
        getData() {
            this.loadData = true;
            const params = {
                "page": this.page,
                "size": this.size,
                // "startTime": this.startDate + " 00:00:00",
                // "endTime": this.endDate + " 23:59:59",
                uid: this.role.uid,
            }
            if (this.startDate) {
                params['startTime'] = this.startDate + " 00:00:00"
            }
            if (this.endDate) {
                params['endTime'] = this.endDate + " 23:59:59"
            }
            if (this.searchStr) {
                params['searchType'] = this.searchType;
                params['searchStr'] = this.searchStr;
            }
            ajaxPost(Baseurl + 'projectController/selectProjectList', params).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        const data = res.data;
                        this.tableData = data.list;
                        this.total = data.total;
                    } else {
                        this.$message.error(res.message);
                    }
                }
                this.loadData = false;
            })
        },
        submit() {
            if(!this.resourceInfo.id){
                this.$message.error('请选择资源');
                return;
            }
            if (!this.resourceInfo.userId){
                this.$message.error('请选择用户');
                return;
            }
            if (!this.resourceInfo.resourceNumber || this.resourceInfo.resourceNumber <= 0) {
                this.$message.error('请填写分配数量');
                return;
            }
            const distributableNum = this.resourceMap[this.resourceInfo.id] ? this.resourceMap[this.resourceInfo.id].resourceQuantity - (this.resourceMap[this.resourceInfo.id].allocatedQuantity || 0) : 0;
            if (this.resourceInfo.resourceNumber > distributableNum) {
                this.$message.error('分配数量不能大于可分配资源数量');
                return;
            }
            const params = {
                resourceId: this.resourceInfo.id,
                uid: this.resourceInfo.userId,
                projectId: this.projectId,
                allocationQuantity: +this.resourceInfo.resourceNumber,
            }
            ajaxPost(Baseurl + 'projectResourceController/insertProjectResourceUser', params).then((resp) => {
                if (resp.status === 200) {
                    const res = resp.data;
                    if (res.code === 200) {
                        this.$message.success('分配成功！');
                        this.showDistributeDialog = false;
                        this.showRow({ id: this.projectId });
                        this.clearDialogData();
                        this.getData();
                    } else {
                        this.$message.error(res.message);
                    }
                }
            })
        },
        clearDialogData() {
            this.personList = [];
            this.projectId = null;
        },
        handleClose() {
            this.clearDialogData();
            this.dialogVisible = false;
        },
        getTableHeader,
        handleSizeChange(val) {
            this.page = 1;
            this.size = val;
            this.getData();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getData();
        },
        createProject() {
            this.dialogVisible = true
        }
    },
};
</script>
<style lang="scss" scoped>
.row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .left,
    .right {
        display: flex;
        align-items: center;
    }

    /deep/ .el-date-editor {
        margin: 0 5px;
    }

    .right {
        .el-button {
            margin-left: 10px;
        }

        .el-select {
            width: 120px;
        }
    }
}

.box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;

    .item {
        width: 30%;
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .label {
            width: 80px;
        }

        .el-input,
        .el-textarea,
        .value,
        .el-select {
            flex: 1;
        }

        &.w100 {
            width: 100%;
        }

        &.w50 {
            width: calc(50% - 10px);
        }
    }

    &.shop {
        display: block;

        .select-box {
            display: flex;

            .select-item {
                display: flex;
                align-items: center;
                margin-right: 10px;

                .select-label {
                    margin-right: 5px;
                }

                .el-select {
                    width: 250px;

                    &.w800 {
                        width: 800px;
                    }
                }
            }
        }
    }
}

/deep/ .el-tabs__content {
    max-height: 500px;
}

.el-tab-pane {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: auto;

    .editable-container {
        width: 100%;
    }



    .last-button {
        margin-top: 5px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
}

.box {
    width: 100%;
    max-height: 465px;
    overflow: auto;
}

.started {
    background-color: #70b603;
    color: #fff;
    padding: 0 5px;
    border-radius: 5px;
    display: inline-block;
}

.not-started {
    background-color: #f5f5f5;
    color: #999;
    padding: 0 5px;
    border-radius: 5px;
    display: inline-block;
}

.page-block {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}

.createBtn {
    margin: 10px 0;
}
</style>